(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["aphome-collections"] && !window.DesignMode) return;
  try {
    
var collectionsSize=$(".aphome-collections").find(".row").children().length;
	var classCol=12/collectionsSize;
	$(".aphome-collections").find(".row").children().each(function(){
		$(this).addClass("col-md-"+classCol);
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logo-bar"] && !window.DesignMode) return;
  try {
    
    $(document).ready(function(){
      $('.logo-bar').slick({
        lazyLoad: 'ondemand',
        slidesToShow: 6,
        slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
      });
    });

  } catch(e) { console.error(e); }
})();

})();
